import { createFileRoute, redirect } from '@tanstack/react-router';
import { CreateEmployeePage } from '@/features/employees/create/create-employee-page';
import { hasAnyPermission } from '@/lib/auth';
import { guardRoute } from '@/lib/route-guards';

export const Route = createFileRoute('/_app/employees/new')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/employees/new');
    // Creating needs more than reading the directory (FR-EMP-1, ADR-008).
    if (!hasAnyPermission(context.auth.user, ['employee.create']))
      throw redirect({ to: '/employees' });
  },
  component: CreateEmployeePage,
});
